/*
 *
 * SCRIPT FOR ENABLING AGE VERIFICATION FOR CART DRAWER
 * Developer - Alexey Osipov (aosipovdev@gmail.com)
 * cart_drawer_age_verification.js
 *
 */

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    console.log("The custom script for drawer has been loaded");

    var targetNode = document.getElementById("cart-drawer");

    var config = { attributes: true, attributeFilter: ["class"] };

    var callback = function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === "attributes") {
          if (mutation.target.classList.contains("is-open")) {
            console.log('The "is-open" class was added!');

            const drawerItems = document.querySelector(".drawer__items");

            const isCartOpen = document
              .querySelector(".drawer--cart")
              .classList.contains("is-open");

            if (drawerItems && isCartOpen) {
              var acceptanceCheckbox = document.getElementById("acceptance");
              var ageVerificationCheckbox = document.getElementById("confirmAge");
              var ageVerificationLabel = document.querySelector("[data-cart-confirm-age-label]");
              var ageErrorElement = document.querySelector(".age-error-message");
              var checkoutButton = document.querySelector(".cart__checkout");
              var ageVerifyProductInCart = false;

              // Ensure the checkout button is always enabled
              checkoutButton.removeAttribute("disabled");
              checkoutButton.classList.remove("cart__buttons--disabled");

              function showAgeErrorMessage() {
                console.log("Showing age error message");
                ageErrorElement.classList.add("is-expanded");
              }

              function hideAgeErrorMessage() {
                console.log("Hiding age error message");
                ageErrorElement.classList.remove("is-expanded");
              }

              function showAgeVerification() {
                ageVerificationCheckbox.style.display = "block";
                ageVerificationLabel.style.display = "block";
              }

              function hideAgeVerification() {
                ageVerificationCheckbox.style.display = "none";
                ageVerificationLabel.style.display = "none";
              }

              checkoutButton.addEventListener("click", function (event) {
                console.log("Button was clicked");
                let canProceed = true;

                if (!acceptanceCheckbox.checked) {
                  console.log("Acceptance checkbox is not checked");
                  canProceed = false;
                }

                if (ageVerifyProductInCart && !ageVerificationCheckbox.checked) {
                  console.log("Age verification required but checkbox is not checked");
                  showAgeErrorMessage();
                  canProceed = false;
                } else {
                  hideAgeErrorMessage();
                }

                if (!canProceed) {
                  event.preventDefault(); // Prevent proceeding to checkout if conditions aren't met
                }
              });

              ageVerificationCheckbox.addEventListener("change", function () {
                if (!ageVerificationCheckbox.checked && ageVerifyProductInCart) {
                  showAgeErrorMessage();
                } else {
                  hideAgeErrorMessage();
                }
              });

              acceptanceCheckbox.addEventListener("change", function () {
                // No action needed here for button state since it's always enabled
              });

              const desiredProducts = [
                "Mindful Microdosing",
                "Mindful Microdosing Program",
                "Radical Wellbeing Set",
              ];

              const cartItems = drawerItems.querySelectorAll(".cart__item");

              cartItems.forEach((item) => {
                const productTitle = item.querySelector(".cart__item__title a").textContent;

                if (desiredProducts.includes(productTitle)) {
                  console.log("Desired product found in cart: " + productTitle);
                  ageVerifyProductInCart = true;
                  showAgeVerification();
                } else {
                  console.log("Product in cart: " + productTitle);
                }
              });

              if (!ageVerifyProductInCart) {
                console.log("No products for age verification");
                hideAgeErrorMessage();
                hideAgeVerification();
              }
            } else {
              console.log("Drawer items element not found or cart drawer is not open.");
            }
          } else {
            console.log('The "is-open" class was removed!');
          }
        }
      }
    };

    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  });
})();